<template>
  <!-- 编辑联系人信息 -->
  <div>
    <van-popup
      v-model="isShow"
      :close-on-popstate="true"
      :style="{ width: '96%' }"
      style=" border-radius: 10px;"
    >
      <van-panel :title="$t('Modify','修改联系人')">
        <van-field
          :label="$t('D007','姓名')"
          :placeholder="$t('lxrxm','联系人姓名')"
          maxlength="20"
          clearable
          v-model="nativeData.linkMan"
        />
        <van-field
          :label="$t('D010','电话')"
          placeholder="联系人手机号码"
          type="tel"
          :maxlength="16"
          v-model="nativeData.linkTel"
          :error-message="phoneErrMsg"
          clearable
        />
        <van-field
          :label="$t('D020','邮箱')"
          placeholder="联系人邮箱"
          maxlength="30"
          clearable
          v-model="nativeData.linkEmail"
          :error-message="emailErrMsg"
        />

        <div
          slot="footer"
          class="text-right"
        >
          <van-button
            size="normal"
            @click="toggle"
            style="height:36px"
            type="primary"
          >
            {{ $t('B008','取消') }}
          </van-button>
          &nbsp;
          <van-button
            style="height:36px"
            size="normal"
            type="info"
            @click="edit"
          >
            {{ $t('B006','确定') }}
          </van-button>
        </div>
      </van-panel>
    </van-popup>
  </div>
</template>
<script>
import { Popup, Field, Button, Panel } from 'vant'
import { validators } from 'Utils/valid'

export default {
  name: 'LdEditLinker',
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Panel.name]: Panel,
    [Button.name]: Button
  },
  props: {
    data: {
      type: [Object, Array],
      default: () => {}
    }
  },
  data() {
    return {
      isShow: false,
      yc:false,
      nativeData: {},
      phoneErrMsg: '',
      emailErrMsg: '',
    }
  },
  methods: {
    edit() {
      if (this.phoneErrMsg !== '') return
      if (this.emailErrMsg !== '') return

      Object.assign(this.data, this.nativeData)
      this.$emit('selected', this.data)
      this.toggle()
    },
    toggle() {
      console.log('000',this.nativeData.linkEmail)
      if(this.nativeData.linkPhone == ''){
        this.yc = false
      }else{
        this.yc = true
      }
      this.isShow = !this.isShow
      if (this.isShow) {
        this.nativeData = JSON.parse(JSON.stringify(this.data))
      }
    }
  },
  watch: {
    'nativeData.linkTel': function(val) {
      if (!validators.mobile(val).valid) {
        this.phoneErrMsg = validators.mobile(val).msg
      } else {
        this.phoneErrMsg = ''
      }
    },
    'nativeData.linkEmail': function(val) {
      if (val !== '' && !validators.email(val).valid) {
        this.emailErrMsg = validators.email(val).msg
      } else {
        this.emailErrMsg = ''
      }
    }
  }
}
</script>
<style>
</style>
